// helpPlugin.js
import Vue from "vue";
import HelpPopup from "@/wam/components/widgets/HelpPopup.vue";

// Global popup instance oluştur
const HelpConstructor = Vue.extend(HelpPopup);
const instance = new HelpConstructor();

document.body.appendChild(instance.$mount().$el);

export default {
  install(Vue) {
    Vue.prototype.$help = function (text, title = "Bilgi") {
      instance.show(text, title);
    };
  }
};